import type { ComponentProps } from 'react';
import { cn } from '@/utils/cn';

export function Card({ className, ...rest }: ComponentProps<'div'>) {
  return <div className={cn('rounded-card bg-white p-4 shadow-card', className)} {...rest} />;
}
